import { render, staticRenderFns } from "./CloneSettingFromDoctor.vue?vue&type=template&id=1ff14bc3&scoped=true&"
import script from "./CloneSettingFromDoctor.vue?vue&type=script&lang=js&"
export * from "./CloneSettingFromDoctor.vue?vue&type=script&lang=js&"
import style0 from "./CloneSettingFromDoctor.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CloneSettingFromDoctor.vue?vue&type=style&index=1&id=1ff14bc3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff14bc3",
  null
  
)

export default component.exports